/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-10-21 10:41:24
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-10 00:09:44
 * @FilePath: \mpc-monorepo\features\common\src\components\MPCFormGrid\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import './index.less'
import classNames from "classnames";
import { DescriptionsItemType } from "@bedrock/components/lib/Descriptions/Item";

const prefixCls = 'mpc-form-grid';

interface MPCFormGridProps {
  items?: DescriptionsItemType[];
  column?: number;
  className?: string;
  labelStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  bordered?: boolean;
}

export default function MPCFormGrid({ 
  items = [], column = 2, className, labelStyle: globalLabelStyle, contentStyle: globalContentStyle, bordered = false,
}: MPCFormGridProps) {

  return (
    <div className={classNames(`${prefixCls}__container`, className)}>
      {/* hack: 借助table元素style={{ tableLayout: 'fixed', width: '100%' }}作为flex布局子孙元素时的自动撑宽能力 */}
      <table style={{ tableLayout: 'fixed', width: '100%' }}></table>
      {/* rock-descriptions-view 兼容MPC历史为Descriptions组件加边框样式 */}
      <div className={classNames(prefixCls, `grid-template-columns-${column}`, { borderMode: bordered }, 'rock-descriptions-view')}>
        {items.map((item, index) => {
          const { children, label, span = 1, labelStyle, contentStyle, ...otherProps } = item;
          return (
            <div className={classNames(`${prefixCls}__item gridColSpan_${span}`)} key={index}>
              <div className={classNames(`${prefixCls}__itemLabel`)} style={{ ...globalLabelStyle, ...labelStyle }} key={index + 'label'} >
                {label}
              </div>
              <div
                // @ts-ignore
                className={classNames(`${prefixCls}__itemContent`, { view: children?.props?.view })}
                style={{ ...globalContentStyle, ...contentStyle }}
                key={index + 'content'}
              >
                {children}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  )
}
